<!--
 * @Descripttion: 项目人员管理
 * @Date: 2024-08-06 13:58:47
-->
<template>
  <div class="project-person-list">
    <xrk-table
      ref="xrkTableRef"
      :getListAjax="getListAjax"
      :searchConfig="searchConfig"
      :tableConfig="tableConfig"
    >
      <template #tableBefore>
        <div
          style="
            margin: 10px;
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <div v-if="isAsp">
            <base-checkbox
              :indeterminate="isIndeterminate"
              v-model="isSelectionAll"
              @change="onSelectionAllChange"
            ></base-checkbox>

            <span style="margin-right: 5px">全选</span>
            <span>已选{{ selectionRows.length }}项：</span>
            <base-button
              v-resource="['停用_启用']"
              :disabled="isEntry === '1,3'"
              type="default"
              @click="onEnable(1)"
            >
              批量停用
            </base-button>
            <base-button
              v-resource="['停用_启用']"
              :disabled="isEntry === '1,3'"
              type="default"
              @click="onEnable(0)"
            >
              批量启用
            </base-button>
            <base-button
              v-if="certificated"
              type="default"
              @click="onBatchAuditQua"
            >
              批量审核资质
            </base-button>
          </div>
          <div style="display: flex; align-items: center" v-if="isAsp">
            <span style="font-size: 14px; height: 22px">往期人员：</span>
            <BaseSwitch
              :active-value="0"
              :inactive-value="1"
              active-text="显示"
              inactive-text="不显示"
              v-model="isCurrentTerm"
              @change="onRefreshTabel"
            ></BaseSwitch>
          </div>
        </div>
      </template>
      <template v-if="tableAfterTips && isAsp" #tableAfter>
        <p
          style="
            display: flex;
            align-items: center;
            color: red;
            margin-top: 10px;
          "
        >
          <BaseIcon size="18" color="red">
            <WarnTriangleFilled />
          </BaseIcon>
          {{ tableAfterTips }}
        </p>
      </template>
    </xrk-table>
    <QualificationsAudit
      :id="detailId"
      :canAudit="canAudit"
      @close="
        () => {
          detailId = '';
          canAudit = false;
          onRefreshTabel();
        }
      "
      v-if="detailId"
    ></QualificationsAudit>
  </div>
</template>

<script lang="tsx" setup>
import { ref, computed, watch } from 'vue';
import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  useSelectColumn,
  useInputColumn,
  createDialog,
  BaseButton,
  BaseIcon,
  BaseDropdown,
  BaseDropdownMenu,
  BaseDropdownItem,
  BaseCheckbox,
  BaseForm,
  BaseFormItem,
  BaseInput,
  BaseSwitch,
  useCreateModal,
  XrkMessage,
  BaseToolTip,
  XrkTableRef
} from 'xrk-components';
import ProjectPersonEdit from '../components/project-person-edit.vue';
import { storeToRefs } from 'pinia';
import {
  ArrowDown,
  WarningFilled,
  InfoFilled,
  WarnTriangleFilled,
  ArrowRightBold
} from '@element-plus/icons-vue';
import AuthStatus from '../components/auth-status.vue';
import QualificationsAudit from '../components/qualifications-audit.vue';
import BatchQualificationsAudit from '../components/batch-qualifications-audit.vue';
import ProjectPersonPurchase from '../components/project-person-purchase.vue';
import ProjectPersonAddAlone from '../components/project-person-add-alone.vue';
import { PAY_PASSAGEWAY_MAPPING } from '@/common/constants/bank/index';
import AuthStatusIndividual from '../components/auth-status-individual.vue';
import ConfirmLetterPreview from '../components/confirm-letter-preview.vue';

import { SceneTypeEnum } from '@/common/constants/project/index';
import { formatter, resource } from '@/utils';
import {
  projectPeopleList,
  enablePeople,
  deletePeople,
  occupationAuthInfo,
  peopleCheck,
  peopleListExport,
  confirmLetter
} from '../data-source/apis';
import { getProjectInfo } from '@/views/project-task/src/data-source/apis';

import { IS_PLATFORM_TYPE_1 } from '@/config/index';
import { userTags } from '@/views/project-task/src/data-source/apis';
import {
  CERTIFICATION_STATUS,
  IN_STATUS,
  OPEN_STATUS_MAPPING,
  USER_AUTH_STATUS,
  OCCUPTION_AUTH_STATUS,
  SIGN_STATUS,
  PROJECT_STATUS
} from '../constants/index';
import { FILE_VIEW_URL } from '@/config';
import { useProjectDetailStore } from '@/views/project-center-edit/src/store';
import appStore from '@/store';
import { getUnqualifiedRowConfig } from '@/utils/unqualified';
import EditUserTag from '../components/edit-user-tag.vue';

// 工业-1 服务商-2 供应商-3
const { defaultUserFnCode } = storeToRefs(appStore.useUserStoreSetup);

/**
 * 是否是服务商
 */
const isAsp = computed(() => defaultUserFnCode.value === 2);
/**
 * 是否是供应商
 */
const isSupplier = computed(() => defaultUserFnCode.value === 3);
/**
 * 是否是工业
 */
const isGy = computed(() => defaultUserFnCode.value === 1);

const store = useProjectDetailStore();
const projectInfo = computed(() => store.baseData.projectInfo);

const taxPattern = computed(() => store.baseData.txnStructInfo.taxPattern);
/**
 * 协定服务
 */
const isSceneType19 = computed(
  () => store.baseData.projectInfo.sceneType === SceneTypeEnum.nineteen
);

//协定服务上传来源1ASP上传2C端上传3双方共同上传
const agreementServiceUploadType = computed<number>(() => {
  return store.baseData.reqsInfo.agreementServiceUploadType;
});

//协定服务上传方式1以活动方式上传2以人为维度上传
const agreementServiceUploadMode = computed<number>(() => {
  return store.baseData.reqsInfo.agreementServiceUploadMode;
});

//职业认证 1-需要 0-不需要
const isExpertiseAuth = computed(() => {
  return store.baseData.execReqsInfo.isExpertiseAuth;
});

//资质认证 1-需要 0-不需要
const certificated = computed(() => {
  return store.baseData.execReqsInfo.certificated;
});

const isEntry = computed(() => {
  return [
    +agreementServiceUploadMode.value,
    +agreementServiceUploadType.value
  ].join(',');
});
// '1,3': '活动形式-双方共同上传',
// '1,1': '活动形式-服务商上传',
// '2,2': '人为维度-终端上传',
// '2,1': '人为维度-服务商上传',

const tableAfterTips = computed(() => {
  const qualsInfoList = store.baseData.execReqsInfo.qualsInfoList
    .flat()
    .map(item => {
      return `【${item.name}】`;
    });
  if (qualsInfoList.length <= 0) {
    return '';
  }
  return `项目资质要求：${qualsInfoList.join('，')}`;
});

const xrkTableRef = ref<XrkTableRef>();

const isSelectionAll = ref(false);

// 勾选列表数据
const selectionRows = computed(() => {
  return xrkTableRef.value?.getSelectionRows() || [];
});

const tableDataRow = ref([]); //当前搜索条件下可勾选的id

const isIndeterminate = computed(() => {
  if (selectionRows.value.length === 0) {
    return false;
  }
  return selectionRows.value.length !== tableDataRow.value.length;
});

const isCurrentTerm = ref(0);

const onSelectionAllChange = (val: boolean) => {
  if (val) {
    tableDataRow.value.forEach(item => {
      xrkTableRef.value.addSelectionRow(item, { userId: item });
    });
  } else {
    xrkTableRef.value.clearSelectionRows();
  }
  isSelectionAll.value = val;
};

// 勾选列表数据变化时，更新全选状态
watch(
  () => selectionRows.value,
  val => {
    if (val.length === 0) {
      isSelectionAll.value = false;
      return;
    }
    isSelectionAll.value = val.length === tableDataRow.value.length;
  }
);

const onRefreshTabel = () => {
  xrkTableRef.value?.initCurrentList();
};

const onEnable = async (status: 1 | 0) => {
  if (selectionRows.value.length === 0) {
    XrkMessage.error('最少选择一条数据操作');
    return;
  }
  const searchVal = xrkTableRef.value?.getSearchValue();

  const { data } = await peopleCheck({
    isCurrentTerm: isCurrentTerm.value,
    projectId: projectInfo.value.id,
    userType: projectInfo.value.ctype === 3 ? 3 : 1,
    buttonType: 1,
    ...searchVal
  });

  const filterData = selectionRows.value.filter(item => {
    return data.userId.find(row => row === item.userId);
  });

  if (filterData.length === 0) {
    XrkMessage.error('当前已勾选的条数无可操作数据，请重新选择');
    return;
  } else {
    const text = status === 0 ? '启用' : '停用';
    createDialog({
      width: 350,
      title: '提示',
      showClose: true,
      content: `是否确认${text}${filterData.length}条数据，请谨慎操作`,
      beforeConfirm: async done => {
        await enablePeople({
          projectId: projectInfo.value.id,
          userId: filterData.map(item => item.userId),
          enabled: status
        });
        onRefreshTabel();
        done();
      }
    });
  }
};

const onBatchAuditQua = async () => {
  if (selectionRows.value.length === 0) {
    XrkMessage.error('最少选择一条数据操作');
    return;
  }
  const searchVal = xrkTableRef.value?.getSearchValue();

  const { data } = await peopleCheck({
    isCurrentTerm: isCurrentTerm.value,
    projectId: projectInfo.value.id,
    userType: projectInfo.value.ctype === 3 ? 3 : 1,
    buttonType: 2,
    ...searchVal
  });

  const filterData = selectionRows.value.filter(item => {
    return data.userId.find(row => row === item.userId);
  });

  if (filterData.length === 0) {
    XrkMessage.error('当前已勾选的条数无可操作数据，请重新选择');
    return;
  } else {
    useCreateModal(BatchQualificationsAudit, {
      selectionRows: filterData,
      projectId: projectInfo.value.id,
      onConfirm() {
        onRefreshTabel();
      }
    });
  }
};

const detailId = ref();
const canAudit = ref();
//是否是个体
const isGeti = computed(() => {
  return projectInfo.value.ctype === 3;
});

//文件预览
const onViewer = url => {
  window.open(`${FILE_VIEW_URL}?t=${Date.now()}&url=${url}`);
};

// 搜索项
const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchBtn: {
    show: true,
    text: '搜索'
  },
  resetBtn: {
    show: true,
    text: '重置'
  },
  searchColumns: [
    isGeti.value &&
      useInputColumn({
        prop: 'individualName',
        label: '个体工商户名称',
        config: {
          type: 'text',
          placeholder: '请输入',
          inputTextReplace: true,
          maxlength: 50
        }
      }),
    isGeti.value &&
      useInputColumn({
        prop: 'individualName',
        label: '所属园区',
        config: {
          type: 'text',
          placeholder: '请输入',
          inputTextReplace: true,
          maxlength: 50
        }
      }),
    useInputColumn({
      prop: 'name',
      label: isGeti.value ? '经营者' : '终端服务人员',
      config: {
        type: 'text',
        placeholder: '请输入',
        inputTextReplace: true,
        maxlength: 50
      }
    }),
    useInputColumn({
      prop: 'phone',
      label: '手机号',
      config: {
        type: 'tel',
        placeholder: '请输入'
      }
    }),
    isAsp.value &&
      useInputColumn({
        type: 'autocomplete' as any,
        prop: 'userTag',
        label: '人员标签',
        config: {
          clearable: true,
          maxlength: 50,
          placeholder: '请选择',
          fetchSuggestions: async (value, cb) => {
            const { data } = await userTags({
              projectId: projectInfo.value.id
            });
            const list = data.map(item => {
              return { value: item.label, label: item.label };
            });

            return cb(list.filter(i => !value || i.value?.indexOf(value) > -1));
          }
        } as any
      }),
    isAsp.value &&
      useSelectColumn({
        prop: 'auditStatus',
        label: '资质状态',
        config: {
          placeholder: '请选择',
          options: CERTIFICATION_STATUS
        }
      }),
    useSelectColumn({
      prop: 'status',
      label: '入驻状态',
      config: {
        placeholder: '请选择',
        options: IN_STATUS
      }
    }),

    useSelectColumn({
      prop: 'payStatus',
      label: '支付通道状态',
      config: {
        placeholder: '请选择',
        options: OPEN_STATUS_MAPPING
      }
    }),
    useSelectColumn({
      prop: 'authStatus',
      label: '实名状态',
      config: {
        placeholder: '请选择',
        options: USER_AUTH_STATUS
      }
    }),
    useSelectColumn({
      prop: 'enabled',
      label: '是否可执行项目',
      config: {
        placeholder: '请选择',
        options: {
          1: { label: '是', value: '1' },
          0: { label: '否', value: '0' }
        }
      }
    })
  ].filter(item => item),
  otherComponents: [
    {
      render() {
        return (
          <>
            <BaseButton
              v-resource={[['导出']]}
              style={{ marginRight: '12px' }}
              type="primary2"
              click={async () => {
                await peopleListExport({
                  isCurrentTerm: isCurrentTerm.value,
                  projectId: projectInfo.value.id,
                  userType: projectInfo.value.ctype === 3 ? 3 : 1,
                  ...xrkTableRef.value.getSearchValue()
                });
              }}
            >
              导出
            </BaseButton>
            {isAsp.value &&
              !['1,3', '1,1'].includes(isEntry.value) &&
              resource.checkPermission('预采购任务量') && (
                <BaseDropdown
                  v-slots={{
                    dropdown: () => (
                      <>
                        <BaseDropdownMenu>
                          <BaseDropdownItem
                            onClick={() => {
                              if (
                                [4, 5].includes(projectInfo.value.projectStatus)
                              ) {
                                XrkMessage.error('项目已暂停/完结 不可添加');
                                return;
                              }
                              useCreateModal(ProjectPersonAddAlone, {
                                projectId: projectInfo.value.id,
                                isSceneType19: isSceneType19.value,
                                onSuccess: () => {
                                  onRefreshTabel();
                                }
                              });
                            }}
                          >
                            单独添加
                          </BaseDropdownItem>
                          <BaseDropdownItem
                            onClick={() => {
                              if (
                                [4, 5].includes(projectInfo.value.projectStatus)
                              ) {
                                XrkMessage.error('项目已暂停/完结 不可添加');
                                return;
                              }
                              useCreateModal(ProjectPersonPurchase, {
                                onSuccess: () => {
                                  onRefreshTabel();
                                },
                                projectId: projectInfo.value.id,
                                isSceneType19: isSceneType19.value
                              });
                            }}
                          >
                            批量添加
                          </BaseDropdownItem>
                        </BaseDropdownMenu>
                      </>
                    )
                  }}
                >
                  <BaseButton type="primary2">
                    {isSceneType19.value ? '项目人员' : '预采购任务量'}
                    <BaseIcon class="el-icon--right">
                      <ArrowDown />
                    </BaseIcon>
                  </BaseButton>
                </BaseDropdown>
              )}
          </>
        );
      }
    }
  ]
});

// 列表
const tableConfig = computed<XrkTableProps['tableConfig']>(() => {
  return {
    tableColumns: [
      isAsp.value &&
        useTableColumn({
          type: '_selection',
          prop: 'userId',
          align: 'center',
          fixed: 'left',
          width: 120,
          selectionDisabled(row) {
            // 选择框有两个功能 1、人员批量停用启用 2、资质审核 有资质审核时则选择框不校验置灰
            if (certificated.value) {
              return false;
            }
            return +row.cancelStatus === 1 || isEntry.value === '1,3';
          }
        }),
      useTableColumn({
        type: 'index',
        label: '序号',
        width: '80px'
      }),
      useTableColumn({
        label: isGeti.value ? '经营者' : '终端服务人员',
        prop: 'name',
        render({ row, cellValue }) {
          return (
            <>
              <div style="display: flex; align-items: center;">
                <span style="margin-right: 5px;">
                  {isGy.value ? formatter.maskName(cellValue) : cellValue}
                </span>
                {row.cancelStatus ? (
                  <BaseToolTip
                    effect="dark"
                    content="已注销不可执行项目"
                    placement="top-start"
                  >
                    <BaseIcon size="15" color="red">
                      <WarningFilled />
                    </BaseIcon>
                  </BaseToolTip>
                ) : (
                  ''
                )}
              </div>
            </>
          );
        }
      }),
      isGeti.value &&
        useTableColumn({
          label: '个体工商户名称',
          prop: 'individualName'
        }),
      isGeti.value &&
        useTableColumn({
          label: '所属园区',
          prop: 'businessParkName'
        }),
      // isGeti.value &&
      //   useTableColumn({
      //     label: '园区费率（%）',
      //     prop: 'parkScale',
      //     formatter: ({ cellValue }) =>
      //       cellValue ? formatter.fen2yuan(cellValue) : '-'
      //   }),
      // isGeti.value &&
      //   useTableColumn({
      //     label: '调整园区费率（%）',
      //     prop: 'personalScale',
      //     formatter: ({ cellValue }) =>
      //       cellValue ? formatter.fen2yuan(cellValue) : '-'
      //   }),
      useTableColumn({
        label: '手机号',
        prop: 'phone'
      }),
      !isGeti.value &&
        isExpertiseAuth.value &&
        useTableColumn({
          label: '职业认证',
          prop: 'occupationAuthStatus',
          render({ cellValue, row }) {
            return (
              <>
                <BaseButton
                  type="text"
                  disabled={cellValue === 1}
                  onClick={async () => {
                    const formItems = [
                      { label: '证书编号', prop: 'certificatesNo' },
                      { label: '医师姓名', prop: 'name' },
                      { label: '省份', prop: 'provinceName' },
                      { label: '医院', prop: 'hospitalName' }
                    ];
                    const { data } = await occupationAuthInfo({
                      userId: row.userId
                    });
                    createDialog({
                      width: 400,
                      title: '职业认证',
                      showClose: true,
                      center: true,
                      confirmBtnConfig: {
                        show: false
                      },
                      cancelBtnConfig: {
                        show: true,
                        content: '关闭'
                      },
                      contentRender: () => (
                        <>
                          <div style="margin: 20px auto;width:280px;">
                            <BaseForm label-position="right">
                              {formItems.map(item => {
                                return (
                                  <BaseFormItem label={item.label}>
                                    <BaseInput
                                      disabled
                                      model-value={data[item.prop]}
                                    ></BaseInput>
                                  </BaseFormItem>
                                );
                              })}
                            </BaseForm>
                          </div>
                        </>
                      )
                    });
                  }}
                >
                  {OCCUPTION_AUTH_STATUS[cellValue]?.label || '-'}
                </BaseButton>
              </>
            );
          }
        }),
      useTableColumn({
        label: '人员标签',
        prop: 'userTag',
        render({ cellValue, row }) {
          return (
            <>
              <BaseButton
                type="text"
                onClick={() => {
                  useCreateModal(EditUserTag, {
                    row,
                    onSuccess: () => {
                      onRefreshTabel();
                    }
                  });
                }}
              >
                {cellValue || '未设置'}
              </BaseButton>
            </>
          );
        }
      }),
      useTableColumn({
        label: '实名状态',
        prop: 'realNameStatus',
        render({ cellValue, row }) {
          return (
            <>
              <BaseButton
                type="text"
                disabled={cellValue !== 1}
                onClick={() => {
                  createDialog({
                    width: 800,
                    title: '实名信息',
                    showClose: true,
                    center: true,
                    confirmBtnConfig: {
                      show: false
                    },
                    cancelBtnConfig: {
                      show: true,
                      content: '关闭'
                    },
                    contentRender: () => {
                      if (isGeti.value) {
                        return (
                          <>
                            <div style="margin: 20px auto;width:680px;">
                              <AuthStatusIndividual
                                userId={row.userId}
                              ></AuthStatusIndividual>
                            </div>
                          </>
                        );
                      }
                      return (
                        <>
                          <div style="margin: 20px auto;width:680px;">
                            <AuthStatus userId={row.userId}></AuthStatus>
                          </div>
                        </>
                      );
                    }
                  });
                }}
              >
                {cellValue === 1 ? '已实名' : '未实名'}
              </BaseButton>
            </>
          );
        }
      }),
      isGeti.value &&
        useTableColumn({
          label: '征收方式',
          prop: 'taxAssessmentMethod',
          formatter: ({ cellValue }) =>
            ({ 1: '核定', 2: '查账', 3: '定期定额' }[cellValue])
        }),
      isGeti.value &&
        useTableColumn({
          label: '申报周期',
          prop: 'taxAssessmentMethod',
          formatter: ({ cellValue }) => ({ 1: '月度', 2: '季度' }[cellValue])
        }),
      useTableColumn({
        label: '支付通道（富友支付）',
        prop: 'payStatus',
        renderHeader() {
          return (
            <div>
              <div>支付通道</div>
              <div>
                {`（${
                  PAY_PASSAGEWAY_MAPPING?.[payPassagewayCode.value]?.label
                }）` || ''}
              </div>
            </div>
          );
        },
        render({ cellValue, row }) {
          return (
            <>
              <BaseButton
                type="text"
                disabled={cellValue !== 3}
                onClick={() => {
                  createDialog({
                    width: 800,
                    title: '开户信息',
                    showClose: true,
                    center: true,
                    confirmBtnConfig: {
                      show: false
                    },
                    cancelBtnConfig: {
                      show: true,
                      content: '关闭'
                    },
                    contentRender: () => {
                      if (isGeti.value) {
                        return (
                          <>
                            <div style="margin: 20px auto;width:680px;">
                              <AuthStatusIndividual
                                userId={row.userId}
                              ></AuthStatusIndividual>
                            </div>
                          </>
                        );
                      }
                      return (
                        <>
                          <div style="margin: 20px auto;width:680px;">
                            <AuthStatus userId={row.userId}></AuthStatus>
                          </div>
                        </>
                      );
                    }
                  });
                }}
              >
                {OPEN_STATUS_MAPPING[cellValue]?.label || '-'}
              </BaseButton>
            </>
          );
        }
      }),
      certificated.value &&
        useTableColumn({
          label: '项目资质',
          prop: 'auditStatus',
          width: 195,
          render({ cellValue, row }) {
            if (row.cancelStatus) {
              return <span>-</span>;
            }
            return (
              <div style="display:flex;align-items:center;justify-content:flex-start;">
                <span>{CERTIFICATION_STATUS[cellValue]?.label}</span>
                {[6, 4].includes(+cellValue) && (
                  <BaseToolTip
                    effect="dark"
                    content={row.opinion}
                    placement="top-start"
                  >
                    <BaseIcon size="15" color="#606266">
                      <InfoFilled />
                    </BaseIcon>
                  </BaseToolTip>
                )}
                {cellValue !== 1 && (
                  <BaseButton
                    style="margin-left:5px;"
                    type="text"
                    onClick={() => {
                      detailId.value = row.userId;
                      canAudit.value = +row.auditStatus === 2;
                    }}
                  >
                    {cellValue === 2 ? '前往审核' : '查看'}
                    <BaseIcon size="12">
                      <ArrowRightBold />
                    </BaseIcon>
                  </BaseButton>
                )}
              </div>
            );
          }
        }),
      !isSceneType19.value &&
        useTableColumn({
          label: '剩余预采购任务量',
          prop: 'remainingPreProcurementTaskQuantity'
        }),
      useTableColumn({
        label: '入驻状态',
        prop: 'status',
        formatter({ cellValue, row }) {
          if (+row.cancelStatus === 1) {
            return '已退出';
          }
          return IN_STATUS[cellValue]?.label;
        }
      }),
      useTableColumn({
        label: '入驻时间',
        prop: 'settlementAt',
        formatter: ({ cellValue }) => formatter.date(cellValue)
      }),
      isAsp.value &&
        useTableColumn({
          label: '项目执行状态',
          prop: 'projectStatus',
          formatter({ cellValue }) {
            return PROJECT_STATUS[cellValue]?.label || '-';
          }
        }),
      isAsp.value &&
        [4, 6, 3, 5].includes(taxPattern.value) &&
        useTableColumn({
          label: '服务商签约状态',
          prop: 'aspSignStatus',
          render({ cellValue, row }) {
            return (
              <>
                <BaseButton
                  type="text"
                  disabled={+cellValue !== 2}
                  onClick={() => {
                    onViewer(row.aspSignUrl);
                  }}
                >
                  {SIGN_STATUS[cellValue]?.label || '-'}
                </BaseButton>
              </>
            );
          }
        }),
      isSupplier.value &&
        [1, 3].includes(taxPattern.value) &&
        useTableColumn({
          label: '供应商签约状态',
          prop: 'mainSupplierSignStatus',
          render({ cellValue, row }) {
            return (
              <>
                <BaseButton
                  type="text"
                  disabled={+cellValue !== 2}
                  onClick={() => {
                    onViewer(row.mainSupplierSignUrl);
                  }}
                >
                  {SIGN_STATUS[cellValue]?.label || '-'}
                </BaseButton>
              </>
            );
          }
        }),
      useTableColumn({
        label: '是否是当期人员',
        prop: 'isCurrentTerm',
        formatter({ cellValue }) {
          return cellValue ? '是' : '否';
        }
      }),
      !IS_PLATFORM_TYPE_1 &&
        !isSupplier.value &&
        useTableColumn({
          label: '项目信息确认函',
          prop: 'confirmLetter',
          render({ row }) {
            return (
              <>
                <BaseButton
                  type="text"
                  disabled={Boolean(!row.isExist)}
                  click={async () => {
                    const res = await confirmLetter({
                      projectId: row.projectId,
                      userId: row.userId
                    });
                    useCreateModal(ConfirmLetterPreview, {
                      detailData: res.data,
                      isAsp: isAsp.value,
                      projectId: row.projectId,
                      userId: row.userId
                    });
                  }}
                >
                  查看
                </BaseButton>
              </>
            );
          }
        }),
      isAsp.value &&
        useTableColumn({
          label: '操作',
          prop: 'handlerCol',
          width: 180,
          fixed: 'right',
          render: ({ row }) => {
            const content =
              row.enabled === 1
                ? '是否确认启用，启用后将可以继续执行项目'
                : '是否确认停用，停用后将不能继续执行项目';
            const text = row.enabled === 1 ? '启用' : '停用';
            return (
              <div>
                <BaseButton
                  v-resource={[['停用_启用']]}
                  type="text"
                  disabled={+row.cancelStatus === 1 || isEntry.value === '1,3'}
                  onClick={() => {
                    createDialog({
                      width: 350,
                      title: '提示',
                      showClose: true,
                      content,
                      beforeConfirm: async done => {
                        await enablePeople({
                          projectId: projectInfo.value.id,
                          userId: [row.userId],
                          enabled: row.enabled === 1 ? 0 : 1
                        });
                        done();
                        onRefreshTabel();
                      }
                    });
                  }}
                >
                  {text}
                </BaseButton>
                <BaseButton
                  type="text"
                  disabled={
                    +row.status === 2 || // 已入驻
                    +row.cancelStatus === 1 || //注销
                    +row.backupsSupplierSignStatus === 2 || // 供应商（1）已签约
                    +row.mainSupplierSignStatus === 2 || // 主供应商已签约
                    +row.aspSignStatus === 2 // 服务商已签约
                  }
                  onClick={() => {
                    createDialog({
                      width: 350,
                      title: '提示',
                      showClose: true,
                      content: '是否确认删除？',
                      beforeConfirm: async done => {
                        await deletePeople({
                          userId: row.userId,
                          projectId: projectInfo.value.id
                        });
                        done();
                        onRefreshTabel();
                      }
                    });
                  }}
                >
                  删除
                </BaseButton>
                <BaseButton
                  type="text"
                  disabled={!(+row.realNameStatus === 2 && !isGeti.value)}
                  onClick={() => {
                    useCreateModal(ProjectPersonEdit, {
                      row,
                      onSuccess: () => {
                        onRefreshTabel();
                      }
                    });
                  }}
                >
                  修改人员
                </BaseButton>
              </div>
            );
          }
        })
    ].filter(item => item),
    baseConfig: {
      rowClassName({ row, rowIndex }) {
        return getUnqualifiedRowConfig({
          row: row,
          rowIndex: rowIndex,
          isNotUnqualified: row?.superviseStatus === 1
        });
      }
    }
  };
});
// const isNotUnqualified = row => {
//   if (row.zbBlackStatus === 2) {
//     return false;
//   }
//   return row.superviseStatus != 3 || row.dataState != 0;
// };
// 获取当前搜索条件下可勾选的id集合
const getCanSelectionIds = async params => {
  const { data } = await peopleCheck(params);
  tableDataRow.value = data.userId || [];
};

const payPassagewayCode = ref(null);
const getProjectInfoData = async () => {
  const { data } = await getProjectInfo({
    projectId: projectInfo.value.id
  });
  payPassagewayCode.value = data.payPassagewayCode;
};
getProjectInfoData();
const getListAjax = async params => {
  const reqData = {
    ...params,
    isCurrentTerm: isCurrentTerm.value,
    projectId: projectInfo.value.id,
    userType: projectInfo.value.ctype === 3 ? 3 : 1
  };
  const data = await projectPeopleList(reqData);
  await getCanSelectionIds(reqData);
  return data;
};
</script>
<style lang="scss" scoped>
::v-deep {
  .xrk-dialog {
    max-width: 1300px !important;
  }
}
</style>
